import React, { useEffect, useRef, useState } from 'react';
import ReportDrawer from '../../../constants/ReportDrawer';
import SidebarOpen from '../../../constants/SidebarOpen';
import { useSidebar } from '../../../helpers/sidebarClose';
import CircleBtn from '../../../constants/CircleBtn';
import ReportHeader from '../../../constants/ReportHeader';
import { useReactToPrint } from "react-to-print";
import { TransactionRpt } from '../../../helpers/models/Models';
import PrintProfitLossRptView from '../../../components/account/reports/profit_loss/PrintProfitLossRptView';
import BanaceSheetRptFormView from '../../../components/account/reports/balance_rpt/BanaceSheetRptFormView';
import BalanceSheetRptListView from '../../../components/account/reports/balance_rpt/BalanceSheetRptListView';
import PrintBalanceSheetRptView from '../../../components/account/reports/balance_rpt/PrintBalanceSheetRptView';

const BalanceSheetReportCreateListView = ({ setIconsButton }: { setIconsButton: any }) => {
    const { isOpen, toggleSidebar, closeSidebar } = useSidebar('balancesheet_report');
    const [onBalnSheetReport, setOnBalnSheetReport] = useState<TransactionRpt[]>([]);
    const componentListRef = useRef<HTMLDivElement | null>(null);

    const handlePrintCard = useReactToPrint({
        content: () => componentListRef.current!,
    });

    useEffect(() => {
        setIconsButton(<CircleBtn onClick={handlePrintCard} />);
        return () => setIconsButton(null);
    }, []);

    useEffect(() => {
        if (!isOpen) {
            toggleSidebar();
        }
    }, [isOpen, toggleSidebar]); 
    return (
        <>
            <SidebarOpen onClick={toggleSidebar} />
            <ReportDrawer header={<ReportHeader label='Balance Sheet Report' />} open={isOpen} onClose={closeSidebar}>
                <BanaceSheetRptFormView setOnBalnSheetReport={setOnBalnSheetReport} />
            </ReportDrawer>
            <BalanceSheetRptListView onBalnSheetReport={onBalnSheetReport} />
            <div className='hidden'>
                <div ref={componentListRef}>
                    <PrintBalanceSheetRptView onBalnSheetReport={onBalnSheetReport} />
                </div>
            </div>
        </>
    );
}

export default BalanceSheetReportCreateListView;
